namespace Solovis.Portal.TxServices {

    export interface TxInvestmentCachedUnitPriceData {
        unitPriceStr?: string;
    }

    /**
     * TxCachedPriceManager manages the set of prices retrieved from the server.
     */
    export class TxCachedPriceManager {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _keyToHolderMap;

        constructor(options?: {
            portalServices?: Solovis.Portal.IPortalServices;
        }) {

            if (options && options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._keyToHolderMap = {};
        }

        public _getScalarKey(investmentId, dayId) {
            return "" + dayId + "-" + investmentId;
        };

        public registerUnitPriceData(investmentId, dayId, unitPriceData: TxInvestmentCachedUnitPriceData) {
            var key = this._getScalarKey(investmentId, dayId);

            var holder = this._keyToHolderMap[key];
            if (!holder) {
                holder = {};
                this._keyToHolderMap[key] = holder;
            }

            holder.unitPriceData = unitPriceData;

            if (holder.callbacks) {
                $(holder.callbacks).each(function (i, callback: any) {
                    try {
                        callback(holder.unitPriceData);
                    }
                    catch (ex) {
                        console.log("TxCachedPriceManager callback error");
                        console.log(ex);
                    }
                });
            }
        }


        /*
         * getUnitPriceDataAsync will request the unitPriceData and callback(unitPriceData) will be called with the result.
         */
        public async getUnitPriceDataAsync(
            investmentId,
            dayId,
            callback: (data: TxInvestmentCachedUnitPriceData) => void = null): Promise<TxInvestmentCachedUnitPriceData> {

            var self = this;

            var key = this._getScalarKey(investmentId, dayId);

            var holder = this._keyToHolderMap[key];
            if (!holder) {
                holder = {
                    dayId: dayId,
                    investmentId: investmentId
                };
                this._keyToHolderMap[key] = holder;
            }

            if (holder.unitPriceData) {
                if (callback) {
                    callback(holder.unitPriceData);
                }

                return holder.unitPriceData;
            }
            else {
                if (!holder.callbacks) {
                    holder.callbacks = [];
                }

                if (callback) {
                    holder.callbacks.push(callback);
                }

                if (!holder.loadPending) {
                    holder.loadPending = true;

                    let unitPriceResponse = await this._portalServices.rpc().invoke(
                        "~/DataManagement/TransactionEditor/GetUnitPriceData",
                        { investmentId: investmentId, dayId: dayId });

                    let unitPriceData: TxInvestmentCachedUnitPriceData = unitPriceResponse.result;

                    this.registerUnitPriceData(investmentId, dayId, unitPriceData);

                    holder.loadPending = false;                    

                    return unitPriceData;
                }
                else if (!callback) {
                    // We called using async/await style and need to register callback to make sure we get called when prior load completes.
                    return new Promise<TxInvestmentCachedUnitPriceData>(function (resolve, reject) {
                        holder.callbacks.push((unitPriceData) => {
                            resolve(unitPriceData);
                        });
                    });
                }
            }
        };

    }

}